// Audit report i18n keys (used by AuditReport.vue and AuditStatsWidget.vue).
// Page-level keys live under `AuditReport.*` and `AuditStatsWidget.*`.

export const reportAuditDict: Record<string, [en: string, th: string]> = {
  // ── Page-level keys (AuditReport) ────────────────────────
  "AuditReport.pageTitle": ["Audit Report", "รายงานตรวจนับ"],
  "AuditReport.breadcrumb": ["Audit Report", "รายงานตรวจนับ"],

  // ── Section title (AuditReport) ──────────────────────────
  "AuditReport.auditHistory": ["Audit History", "ประวัติการตรวจนับ"],

  // ── Stats widget (AuditStatsWidget) ──────────────────────
  "AuditStatsWidget.pageTitle": ["Audit Statistics", "สถิติการตรวจนับ"],
  "AuditStatsWidget.stat.thisMonth": ["This Month", "เดือนนี้"],
  "AuditStatsWidget.stat.thisYear": ["This Year", "ปีนี้"],
  "AuditStatsWidget.stat.accuracy": ["Accuracy", "ความแม่นยำ"],
  "AuditStatsWidget.stat.auditsSub": ["audits", "ครั้ง"],
  "AuditStatsWidget.stat.thisMonthSub": ["this month", "เดือนนี้"],
  "AuditStatsWidget.chartTitle": ["Monthly Audit Count — {year}", "จำนวนครั้งการตรวจนับรายเดือน — {year}"],
  "AuditStatsWidget.chart.empty": ["No data", "ไม่มีข้อมูล"],
  "AuditStatsWidget.chart.tooltipAudit": ["{count} audit{count|1:;s}", "{count} ครั้ง"],

  // ── Filters ─────────────────────────────────────────────
  "AuditReport.search": ["Search auditor / notes", "ค้นหาผู้ตรวจ / บันทึก"],
  "AuditReport.filter.location": ["All Locations", "ทุกตำแหน่ง"],

  // ── Table column headers ───────────────────────────────
  "AuditReport.column.no": ["No.", "ลำดับ"],
  "AuditReport.column.date": ["Date", "วันที่"],
  "AuditReport.column.auditor": ["Auditor", "ผู้ตรวจ"],
  "AuditReport.column.location": ["Location", "ตำแหน่ง"],
  "AuditReport.column.method": ["Method", "ช่องทาง"],
  "AuditReport.column.result": ["Result", "ผลตรวจ"],
  "AuditReport.column.actions": ["Actions", "จัดการ"],
  "AuditReport.column.wine": ["Wine", "ไวน์"],
  "AuditReport.column.status": ["Status", "สถานะ"],

  // ── Result column sub-labels ────────────────────────────
  "AuditReport.result.expected": ["{count} expected", "คาดว่าจะพบ {count}"],
  "AuditReport.result.found": ["{count} found", "พบจริง {count}"],
  "AuditReport.result.missing": ["{count} missing", "หายไป {count}"],
  "AuditReport.result.unexpected": ["{count} unexpected", "เกินมา {count}"],

  // ── Drawer header / summary cards ───────────────────────
  "AuditReport.drawer.title": ["Audit — {date}", "การตรวจนับ — {date}"],
  "AuditReport.drawer.auditor": ["Auditor: {name}", "ผู้ตรวจ: {name}"],
  "AuditReport.drawer.expected": ["Expected", "คาดว่าจะพบ"],
  "AuditReport.drawer.found": ["Found", "พบจริง"],
  "AuditReport.drawer.missing": ["Missing", "หายไป"],
  "AuditReport.drawer.unexpected": ["Unexpected", "เกินมา"],
  "AuditReport.drawer.accuracy": ["Accuracy", "ความแม่นยำ"],
  "AuditReport.drawer.notesLabel": ["Notes:", "หมายเหตุ:"],

  // ── Report tabs (drawer) ────────────────────────────────
  "AuditReport.tab.bottles": ["By Bottle", "รายขวด"],
  "AuditReport.tab.location": ["By Location", "รายตำแหน่ง"],
  "AuditReport.tab.wine": ["By Wine", "รายไวน์"],

  // ── Bottle filter ───────────────────────────────────────
  "AuditReport.bottleFilter.all": ["All", "ทั้งหมด"],
  "AuditReport.bottleFilter.found": ["Found", "พบจริง"],
  "AuditReport.bottleFilter.notFound": ["Not Found", "ไม่พบ"],
  "AuditReport.bottleFilter.wrong": ["Wrong Location", "ผิดตำแหน่ง"],

  // ── Group report table column headers ───────────────────
  "AuditReport.group.location": ["Location", "ตำแหน่ง"],
  "AuditReport.group.wine": ["Wine", "ไวน์"],
  "AuditReport.group.total": ["Total", "ทั้งหมด"],
  "AuditReport.group.found": ["Found", "พบ"],
  "AuditReport.group.missing": ["Missing", "หายไป"],
  "AuditReport.group.unexpected": ["Unexpected", "เกินมา"],

  // ── Method labels ───────────────────────────────────────
  "AuditReport.method.mobile": ["Mobile", "มือถือ"],
  "AuditReport.method.desktop": ["Desktop", "คอมพิวเตอร์"],

  // ── Result status labels ────────────────────────────────
  "AuditReport.status.found": ["Found", "พบจริง"],
  "AuditReport.status.notFound": ["Not found", "ไม่พบ"],
  "AuditReport.status.wrong": ["Wrong location", "ผิดตำแหน่ง"],
};
